function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.2,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 -52.41490262489418 684 684",
    width: 25,
    height: 25
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 552.5,
    width: 684,
    height: 26.3,
    style: {
      "fill": "rgb(30, 38, 62)"
    },
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.6,313.1 502.5,292 355.2,442 355.2,0 328.9,0 328.9,442 181.5,292 160.5,313.1 342,492  ",
    style: {
      "fill": "rgb(30, 38, 62)"
    },
    vectorEffect: "non-scaling-stroke"
  }))));
};

export default __webpack_public_path__ + "static/media/download.e87dd8e7.svg";
export { SvgComponent as ReactComponent };